import { getDate as getDateFns, getDay as getDayFns, getISODay as getISODayFns, getISOWeek as getISOWeekFns, getMonth as getMonthFns, getTime as getTimeFns, getYear as getYearFns, isSameMonth as isSameMonthFns, } from "date-fns";
import { endOfDay, startOfDay } from "./operations";
/**
 * @param {Date | number} date
 * @param {'start' | 'end'} [format]
 * @returns {number}
 */
const getDate = (date, format) => {
    if (format === "start")
        return getDateFns(startOfDay(date));
    if (format === "end")
        return getDateFns(endOfDay(date));
    return getDateFns(date);
};
/**
 * @param {Date | number} date
 * @param {'start' | 'end'} [format]
 * @returns {number}
 */
const getTime = (date, format) => {
    if (format === "start")
        return getTimeFns(startOfDay(date));
    if (format === "end")
        return getTimeFns(endOfDay(date));
    return getTimeFns(date);
};
/**
 * @param {Date | number} date
 * @returns {number}
 */
const getDay = (date) => {
    return getDayFns(date);
};
/**
 * @param {Date | number} date
 * @returns {number}
 */
const getISODay = (date) => {
    return getISODayFns(date);
};
/**
 * @param {Date | number} date
 * @returns {number}
 */
const getISOWeek = (date) => {
    return getISOWeekFns(date);
};
/**
 * @param {Date | number} date
 * @returns {number}
 */
const getMonth = (date) => {
    return getMonthFns(date);
};
/**
 * @param {number} index
 * @returns {number}
 *
 */
const getMonthByIndex = (index) => {
    return getMonthFns(new Date(0, index));
};
/**
 * @param {Date | number} date
 * @param {Date | number} compareDate
 * @returns {boolean}
 */
const isSameMonth = (date, compareDate) => {
    return isSameMonthFns(date, compareDate);
};
/**
 * @param {Date | number} date
 * @returns {number}
 */
const getYear = (date) => {
    return getYearFns(date);
};
/**
 * @param {boolean} [encoded]
 * @returns {string}
 **/
const getUserTimeZone = (encoded) => {
    if (encoded)
        return encodeURIComponent(Intl.DateTimeFormat().resolvedOptions().timeZone);
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
};
export { getDate, getTime, getDay, getISODay, getISOWeek, getMonth, getMonthByIndex, getYear, getUserTimeZone, isSameMonth };
